/*
 * @Author: lyx
 * @Date: 2024-12-10 16:47:37
 * @LastEditTime: 2023-06-29 11:02:51
 * @FilePath: /dbrank_b/src/routes/visualChart/P39/index.js
 * @Description: p39
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title39 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';
import DBTable from '../components/DBTable';
import FormChart from './FormChart';

class P39 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],

      tableColumns: [],
      tableList: [],
      tableColorList: [],
    }
  }
  getMedian = (numbers) =>{
    return Math.ceil(numbers / 2)
  }

  fillColor = (tableColumns) => {
    const border = `none`
    return tableColumns.map((item, index) => {
      return {
        ...item,
        style: (_, i) => {
          return {
            ...item.style,
            height: 50,
            fontSize: 18,
            textAlign: 'center',
            fontWeight: 'bold',
            // color: '#000',
            color: i === this.getMedian(tableColumns.length+1) ? 'red' : '#000',
            background: '#fff',
            borderRight: border,
            borderBottom: i !== 0 ? '1px solid #000' : border,
          }
        },
        colStyle: (_, ii, i) => {
          return {
            height: 50,
            fontSize: 16,
            textAlign: 'center',
            fontWeight: 'bold',
            color: i === this.getMedian(tableColumns.length+1) ? 'red' : '#000',
            background: '#fff',
            borderRight: border,
            borderBottom: i !== 0 ? '1px solid #000' : border,
          }
        }
      }
    })
  }

  render() {
    const { chartTitle, chartList, tableColumns, tableList, chartColorList } = this.state;
    return (
      <Stage>
        <Title39 pageNumber="2.16">安踏 | 负面发酵率与负面认知分析
        </Title39>

        <div className={s.content}>
          <div>
            <div contentEditable className={s.des}>
              安踏负面发酵率达15.95%，意即在94条负面内容中，有15条的阅转评赞数较高，与竞品比处于正常区间。但其负面内容和观点值得重视——用户在微博上吐槽领奖服设计丑、少数自媒体批评质量服务问题、“没有接住樊振东夺冠带来的泼天流量”等
            </div>
          </div>

          <div className={s.uiWrapper}>
            <div className={s.chartWrapper}>
              <TooltipDrawer
                style={{ width: '100%', height: '100%' }}
                formContent={<FormChart onChange={values => this.setState({ ...values })} />}>
                <Chart options={setChart({
                  label: chartTitle,
                  list: chartList,
                  color: chartColorList
                })} />
              </TooltipDrawer>
            </div>

            <div className={s.tableWrapper}>
              <TooltipDrawer formContent={<Form onChange={values => this.setState({ ...values })} />}>
                <DBTable columns={this.fillColor(tableColumns)} data={tableList} style={{ boxShadow: 'none' }} />
              </TooltipDrawer>
            </div>
            <div className={s.tip} contentEditable><span>负面发酵率：</span>用于衡量“头部”负面内容的占比状况，理想状况是负面内容少、同时负面发酵率低，这意味着一般性的负面内容不会构成重大伤害，且不会引发后续危机。</div>
            <div className={s.tip} contentEditable><span>计算公式为：</span>负面发酵率=（发酵总条数/负向总条数）× 100%。</div>
            <div className={s.tip} contentEditable>品牌相关内容满足以下任一条件的内容，计入该品牌的“<span>负向发酵条数</span>”：①微博：转发≧10或评论≧10；②微信号文章：阅读数≧1000；③头条号/网易号等平台文章：阅读数≧5000或评论数≧20；④新闻网页类文章：该主题内容的相似文章数量≧5；⑤知乎：赞同数≧10，或者评论数≧5。</div>
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P39);



// WEBPACK FOOTER //
// src/routes/visualChart/P39/index.js